import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from './_guards/login.guard';
import { DashboardRetiradoGuard } from './_guards/dashboard-retirado.guard';
import { ModuloBiComponent } from './_components/modulo-bi/modulo-bi.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { IndexDashboardComponent } from './_components/dashboard/index-dashboard/index-dashboard.component';
import { MatDialogModule } from '@angular/material';
import { HistorialRutaComponent } from './_components/dashboard/historial-ruta/historial-ruta.component';
import { HistoricDataComponent } from './_pages/historic-data/historic-data.component';
import { NewModuloBiComponent } from './_components/new-modulo-bi/new-modulo-bi.component';
import { BiSpeedLimitComponent } from './_components/new-modulo-bi/bi-speed-limit/bi-speed-limit.component';
import { BiEmergencyStopComponent } from './_components/new-modulo-bi/bi-emergency-stop/bi-emergency-stop.component';



const routes: Routes = [
  { path: 'modulobi', component: ModuloBiComponent, canActivate: [LoginGuard]},
  { path: 'BI/usabilidad', component: NewModuloBiComponent, canActivate: [LoginGuard]},
  { path: 'BI/exceso_velocidad', component: BiSpeedLimitComponent, canActivate: [LoginGuard]},
  { path: 'BI/paradas_emergencia', component: BiEmergencyStopComponent, canActivate: [LoginGuard]},
  { path: 'login', loadChildren: './login/login.module#LoginModule', data: {title: 'Tranciti | Login' }},
  { path: '', loadChildren: './login/login.module#LoginModule', data: {title: 'Tranciti | Login' }},
  { path: 'dashboard/logclaude', loadChildren: './logclaude/logclaude.module#LogclaudeModule', data: {title: 'Tranciti | Conectar Claude' }},
{
  path: 'dashboard',
  component: DashboardComponent,
  canActivate: [DashboardRetiradoGuard],
  children: [
    {
      path: '',
      component: IndexDashboardComponent
    },
    {
      path: 'historialRuta',
      component: HistorialRutaComponent
    },
    {
      path: 'hist',
      component: HistoricDataComponent
    },
  ],
  data: {
    title: 'Tranciti | Dashboard'
  }
},
{ path: '**', loadChildren: './error/error.module#ErrorModule'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {useHash: true}),
    MatDialogModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
